__turbopack_context__.v({
  "icon": "Loader-module__M8BPBG__icon",
  "loader-animation": "Loader-module__M8BPBG__loader-animation",
  "root": "Loader-module__M8BPBG__root",
});
